<template>
  <div class="productBox">
    <div class="searchBox">
      <div class="searchLeft">
        <el-input
          size="medium"
          v-model="searchForm.productName"
          placeholder="请输入产品名称"
          @keyup.enter.native="getTableList"
        ></el-input>
        <el-button size="medium" type="primary" icon="el-icon-search" @click="getTableList">查询</el-button>
      </div>
      <div class="searchRight">
        <el-button size="medium" type="primary" icon="el-icon-plus" @click="addFunc">增加</el-button>
      </div>
    </div>
    <el-table
    border
    :data="tableData"
    height="73vh"
    style="width: 100%">
    <el-table-column
      prop="productId"
      label="产品编号">
    </el-table-column>
    <el-table-column
      width="140px"
      prop="productName"
      label="产品名称">
    </el-table-column>
    <el-table-column
      width="80"
      prop="availablePower"
      label="产品类型">
      <template slot-scope="scope">
        <span>{{scope.row.productType==1?'封装':scope.row.productType==2?'销售':scope.row.productType==4?'联合存储':'预售'}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="singeNum"
      label="单份算力">
      <template slot-scope="scope">
        <span>{{scope.row.singeNum}} TiB</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="contract"
      label="服务周期">
      <template slot-scope="scope">
        <span>{{scope.row.contract}} 天</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="freeCycle"
      label="线性释放">
      <template slot-scope="scope">
        <span>{{scope.row.freeCycle}} 天</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="freezeRatio"
      label="冻结比例">
      <template slot-scope="scope">
        <span>{{scope.row.freezeRatio}} %</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="createTime"
      label="收益类型">
      <template slot-scope="scope">
        <span>{{scope.row.incomeType==1?'固定时间':'逐日时间'}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="earnings"
      width="100px"
      label="收益时间">
      <template slot-scope="scope">
        <span>{{scope.row.earnings}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="pledge"
      label="质押币">
      <template slot-scope="scope">
        <span>{{scope.row.pledge}} FIL</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="gasPledg"
      label="GAS费">
      <template slot-scope="scope">
        <span>{{scope.row.gasPledg}} FIL</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="trus"
      label="托管费用">
      <template slot-scope="scope">
        <span>{{scope.row.trus}} %</span>
      </template>
    </el-table-column>
    <!-- <el-table-column
      prop="repertory"
      label="产品可售数">
    </el-table-column> -->
    <el-table-column
    width="100px"
      prop="productSale"
      label="已销售数量">
    </el-table-column>
    <el-table-column
      prop="createTime"
      label="是否展示">
      <template slot-scope="scope">
        <span>{{scope.row.showType==1?'是':'否'}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="createTime"
      label="是否下单">
      <template slot-scope="scope">
        <span>{{scope.row.placeType==1?'是':'否'}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="createTime"
      width="160px"
      label="创建时间">
    </el-table-column>
    <el-table-column
      width="170"
      label="操作">
      <template slot-scope="scope">
        <el-button size="mini" type="primary" @click="getEidt(scope.row)"><i class="el-icon-view" style="margin-right:3px;"></i>编辑</el-button>
        <el-button size="mini" type="primary" @click="getCont(scope.row)"><i class="el-icon-edit" style="margin-right:3px;"></i>产品描述</el-button>
      </template>
    </el-table-column>
    </el-table>
    <div class="pageBox" v-if="totalNum > 0">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.page"
        :page-sizes="[20, 50, 100, 500]"
        :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
      >
      </el-pagination>
    </div>
    <el-dialog
    :title="ruleForm.id?'编辑产品':'新增商品'"
    :visible.sync="dialogVisible"
    width="1000px">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="160px" class="demo-ruleForm minercode">
			<el-row>
				<el-col :span="8">
					<el-form-item label="产品名称" prop="productName">
						<el-input placeholder="请输入产品名称" v-model="ruleForm.productName" style="width:160px" type="text" ></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="产品种类" prop="productCurrency">
						<el-input placeholder="请输入产品种类" disabled v-model="ruleForm.productCurrency" style="width:160px" type="text"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="服务周期(天)" prop="contract">
						<el-input placeholder="请输入服务周期" v-model="ruleForm.contract" style="width:160px" type="text" @input="ruleForm.contract = String(ruleForm.contract).replace(/[^\d]/g,'')"   ng-pattern="/[^a-zA-Z]/"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="8">
					<el-form-item label="质押币(FIL)" prop="pledge">
						<el-input placeholder="请输入质押币(FIL)" v-model="ruleForm.pledge" style="width:160px" type="number" ></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="Gas费(FIL)" prop="gasPledg">
						<el-input placeholder="请输入Gas费(FIL)" v-model="ruleForm.gasPledg" style="width:160px" type="number" ></el-input>
					</el-form-item>
				</el-col>
        <el-col :span="8">
					<el-form-item label="托管费用(%)" prop="trus">
						<el-input placeholder="请输入托管费用" v-model="ruleForm.trus" style="width:160px" type="text" @input="ruleForm.trus = String(ruleForm.trus).replace(/[^\d]/g,'')"   ng-pattern="/[^a-zA-Z]/"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
      <el-row>
				<el-col :span="8">
					<el-form-item label="1TiB固定成本(USDT)" prop="fixCost">
						<el-input placeholder="请输入固定成本" v-model="ruleForm.fixCost" style="width:160px" type="text" @input="ruleForm.fixCost = String(ruleForm.fixCost).replace(/[^\d]/g,'')"   ng-pattern="/[^a-zA-Z]/"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="FIL基准价格(USDT)" prop="basePrice">
						<el-input placeholder="请输入FIL基准价格" v-model="ruleForm.basePrice" style="width:160px" type="text" @input="ruleForm.basePrice = String(ruleForm.basePrice).replace(/[^\d]/g,'')"   ng-pattern="/[^a-zA-Z]/" ></el-input>
					</el-form-item>
				</el-col>
        <el-col :span="8">
					<el-form-item label="价格调整区间(%)" prop="priceRange">
						<el-input placeholder="请输入价格调整区间" v-model="ruleForm.priceRange" style="width:160px" type="text" @input="ruleForm.priceRange = String(ruleForm.priceRange).replace(/[^\d]/g,'')"   ng-pattern="/[^a-zA-Z]/" ></el-input>
					</el-form-item>
				</el-col>
			</el-row>
      <el-row>
        <el-col :span="8">
					<el-form-item label="单份算力(TiB)" prop="singeNum">
						<el-input placeholder="请输入单份算力" v-model="ruleForm.singeNum" style="width:160px" type="text" @input="ruleForm.singeNum = String(ruleForm.singeNum).replace(/[^\d]/g,'')"   ng-pattern="/[^a-zA-Z]/" ></el-input>
					</el-form-item>
				</el-col>
				<!-- <el-col :span="8">
					<el-form-item label="产品总量(份)" prop="repertory">
						<el-input placeholder="请输入产品总量" v-model="ruleForm.repertory" disabled style="width:160px" type="text" @input="ruleForm.repertory = String(ruleForm.repertory).replace(/[^\d]/g,'')"   ng-pattern="/[^a-zA-Z]/" ></el-input>
					</el-form-item>
				</el-col> -->
        <el-col :span="8">
					<el-form-item label="冻结比例(%)" prop="freezeRatio">
						<el-input placeholder="请输入冻结比例" v-model="ruleForm.freezeRatio" style="width:160px" type="number"></el-input>
					</el-form-item>
				</el-col>
        <el-col :span="8">
					<el-form-item label="线性释放周期" prop="freeCycle">
						<el-input placeholder="请输入线性释放周期" v-model="ruleForm.freeCycle" style="width:160px" type="text" @input="ruleForm.freeCycle = String(ruleForm.freeCycle).replace(/[^\d]/g,'')"   ng-pattern="/[^a-zA-Z]/" ></el-input>
					</el-form-item>
				</el-col>
			</el-row>
      <el-row>
        <el-col :span="8">
					<el-form-item label="收益类型" prop="incomeType">
						<el-radio-group v-model="ruleForm.incomeType">
              <el-radio label="1">固定</el-radio>
              <el-radio label="2">逐日</el-radio>
            </el-radio-group>
					</el-form-item>
				</el-col>
        <el-col :span="8">
					<el-form-item label="收益时间" prop="incomeDelayDays" v-if="ruleForm.incomeType==2">
						<el-input placeholder="请输入收益时间" v-model="ruleForm.incomeDelayDays" style="width:160px" type="number" onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"></el-input>
          </el-form-item>
          <el-form-item label="收益时间" prop="incomeStartDate" v-else>
            <el-date-picker
              v-model="ruleForm.incomeStartDate"
              type="date"
              :picker-options="pickerOptions"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
				</el-col>
        <el-col :span="8">
					<el-form-item label="产品类型" prop="productType">
						<!-- <el-radio-group v-model="ruleForm.productType">
              <el-radio label="1">封装</el-radio>
              <el-radio label="2">销售</el-radio>
            </el-radio-group> -->
            <el-select v-model="ruleForm.productType"  placeholder="请选择产品类型">
              <el-option
                v-for="item in productTypeList"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
					</el-form-item>
				</el-col>
			</el-row>
      <el-row>
				<el-col :span="8">
					<el-form-item label="是否展示" prop="showType">
            <el-radio-group v-model="ruleForm.showType">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
				</el-col>
        <el-col :span="8">
					<el-form-item label="是否允许购买" prop="placeType">
						<el-radio-group v-model="ruleForm.placeType">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
					</el-form-item>
				</el-col>
        <el-col :span="8">
					<el-form-item label="固定成本折扣(%)" prop="costDiscount">
						<el-input placeholder="请输入折扣百分比" v-model="ruleForm.costDiscount" style="width:160px" type="text" @input="ruleForm.costDiscount = String(ruleForm.costDiscount).replace(/[^\d]/g,'')"   ng-pattern="/[^a-zA-Z]/"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
      <el-row>
        <el-col :span="8">
					<el-form-item label="产品价格类型" prop="priceStrategy">
						<!-- <el-radio-group v-model="ruleForm.priceStrategy">
              <el-radio label="market">市场</el-radio>
              <el-radio label="multi">混合</el-radio>
            </el-radio-group> -->
            <el-select v-model="ruleForm.priceStrategy"  placeholder="请选择">
              <el-option
                v-for="item in priceStrategyList"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="1TiB固定成本(CNY)" prop="fixCnyCost">
						<el-input placeholder="请输入1TiB固定成本(CNY)" v-model="ruleForm.fixCnyCost" style="width:160px" type="text" @input="ruleForm.fixCnyCost = String(ruleForm.fixCnyCost).replace(/[^\d]/g,'')"   ng-pattern="/[^a-zA-Z]/"></el-input>
					</el-form-item>
				</el-col>
        <el-col :span="8">
					<el-form-item label="产品英文" prop="productNameEn">
						<el-input placeholder="请输入产品英文名称" v-model="ruleForm.productNameEn" style="width:160px" type="text"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
      <el-row>
        <el-col :span="8">
					<el-form-item label="最小购买份数" >
						<el-input placeholder="请输入最小购买份数" v-model="ruleForm.minNum" style="width:160px" type="number" @input="ruleForm.minNum = String(ruleForm.minNum).replace(/[^\d]/g,'')"   ng-pattern="/[^a-zA-Z]/"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="最大购买份数" >
						<el-input placeholder="请输入最大购买份数" v-model="ruleForm.maxNum" style="width:160px" type="number" @input="ruleForm.maxNum = String(ruleForm.maxNum).replace(/[^\d]/g,'')"   ng-pattern="/[^a-zA-Z]/"></el-input>
					</el-form-item>
				</el-col>
        <el-col :span="8">
					<el-form-item label="技术返点(%)">
						<el-input placeholder="请输入技术返点比例" v-model="ruleForm.rebate" style="width:160px" type="number" @input="ruleForm.rebate = String(ruleForm.rebate).replace(/[^\d]/g,'')"   ng-pattern="/[^a-zA-Z]/"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
      <el-row>
        <el-col :span="16">
					<el-form-item label="销售区域黑名单" class="quyu">
						<el-select v-model="ruleForm.areaCodes" multiple placeholder="请选择">
              <el-option
                v-for="item in countryList"
                :key="item.code"
                :label="item.name"
                :value="item.code">
              </el-option>
            </el-select>
					</el-form-item>
				</el-col>
			</el-row> 
    </el-form>
    <div style="margin-left:46px;font-weight:bold">1TiB折扣后售价：{{Math.ceil(Number(ruleForm.fixCost)*Number(ruleForm.costDiscount)/100) + ' USDT'}}</div>
    <span slot="footer" class="dialog-footer">
			<el-button @click="resetForm('ruleForm')">取 消</el-button>
			<el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
    </span>
    </el-dialog>
    <!-- 产品描述 -->
    <el-dialog 
    title="产品描述"
    :visible.sync="dialogVisibleTwo"
    class="contDialog"
    width="800px">
      <div>
        <div class="cont_ms">
          <div>中文描述</div>
          <editor-bar v-model="productContent" :isClear="isClear" v-if="editorIf"></editor-bar>
        </div>
        <div class="cont_ms">
          <div>英文描述</div>
          <editor-bar v-model="productContentEn" :isClear="isClear" v-if="editorIf"></editor-bar>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleTwo=false">取 消</el-button>
          <el-button type="primary" @click="submit()">确 定</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import EditorBar from "../../components/wangEditor/index";
export default {
  data() {
    var checkNum = (rule, value, callback) => {
      var reg = /^[0-9]*[0-9][0-9]*$/
      if (value==='') {
        return callback(new Error('请输入线性释放周期'));
      }else {
        if (!reg.test(value)) {
          callback(new Error('输入必须为整数'));
        } else {
          callback();
        }
      }
    };
    var checkNum1 = (rule, value, callback) => {
      var reg = /^[0-9]*[0-9][0-9]*$/
      if (value==='') {
        return callback(new Error('请输入冻结比例'));
      }else {
        if (!reg.test(value)||value<0||value>100) {
          callback(new Error('必须为整数且范围0-100'));
        } else {
          callback();
        }
      }
    };
    var checkNum2 = (rule, value, callback) => {
      var reg = /^[0-9]*[0-9][0-9]*$/
      if (value==='') {
        return callback(new Error('请输入折扣百分比'));
      }else {
        if (!reg.test(value)||value<0||value>100) {
          callback(new Error('必须为整数且范围0-100'));
        } else {
          callback();
        }
      }
    };
    return {
      pickerOptions:{
        disabledDate(time) {
        //Date.now()是javascript中的内置函数，它返回自1970年1月1日00:00:00 UTC以来经过的毫秒数。
            return time.getTime() < Date.now() - 8.64e7;
        }
      },
      totalNum:0,
      searchForm:{
        page:1,
        pageSize:20,
        productName: ''
      },
      ruleForm:{
        id:'',
        productName: '',
        productCurrency: 'FIL',
        contract: '',
        singeNum: '',
        repertory: '0',
        pledge: '',
        gasPledg: '',
        trus: '',
        productType: '',
        showType: '',
        placeType: '',
        fixCost: '',
        basePrice: '',
        priceRange: '',
        incomeType: '1',
        incomeDelayDays: '',
        incomeStartDate: '',
        freezeRatio: '',
        freeCycle: '',
        priceStrategy: '',
        costDiscount: '',
        productNameEn: '',
        areaCodes: [],
        rebate: '0',
        minNum: '1',
        maxNum: null,
        fixCnyCost: null
      },
      tableData: [],
      dialogVisible:false,
      dialogVisibleTwo: false,
      countryList: [],
      rules:{
        productName: [
          { required: true, message: '请输入产品名称', trigger: 'blur' },
        ],
        productCurrency:[
            { required: true, message: '请输入产品种类', trigger: 'blur' }
        ],
				contract:[
            { required: true, message: '请输入服务周期', trigger: 'blur' }
        ],
				singeNum: [
          { required: true, message: '请输入单份算力', trigger: 'blur' },
        ],
        repertory:[
            { required: true, message: '请输入产品总量', trigger: 'blur' }
        ],
        freezeRatio:[
            { required: true, validator: checkNum1, trigger: 'blur' }
        ],
        freeCycle:[
            { required: true, validator: checkNum, trigger: 'blur' }
        ],
        pledge:[
            { required: true, message: '请输入质押币', trigger: 'blur' }
        ],
        gasPledg:[
            { required: true, message: '请输入GAS费', trigger: 'blur' }
        ],
        trus:[
            { required: true, message: '请输入托管费用', trigger: 'blur' }
        ],
        productType: [
          { required: true, message: '请选择产品类型', trigger: 'change' }
        ],
        showType: [
          { required: true, message: '请选择是否展示', trigger: 'change' },
        ],
        placeType: [
          { required: true, message: '请选择是否下单', trigger: 'change' },
        ],
        fixCost:[
            { required: true, message: '请输入固定成本', trigger: 'blur' }
        ],
        basePrice:[
            { required: true, message: '请输入FIL基准价格', trigger: 'blur' }
        ],
        priceRange:[
            { required: true, message: '请输入调整区间', trigger: 'blur' }
        ],
				incomeType:[
            { required: true, message: '请选择收益类型', trigger: 'blur' }
        ],
        incomeStartDate:[
            { required: true, message: '请选择收益时间', trigger: 'blur' }
        ],
        incomeDelayDays:[
            { required: true, message: '请选择收益时间', trigger: 'blur' }
        ],
        priceStrategy:[
            { required: true, message: '请选择产品价格类型', trigger: 'blur' }
        ],
        costDiscount:[
            { required: true, validator: checkNum2, trigger: 'blur' }
        ],
      },
      priceStrategyList: [
        {
          value: 'market',
          name: '市场'
        },
        {
          value: 'multi',
          name: '混合'
        },
        {
          value: 'cny',
          name: '人民币'
        }
      ],
      productContent: '',
      isClear: false,
      editorIf: true,
      productContentEn: '',
      ruleFormTwo:{},
      productTypeList: [
        {name:'封装', value: '1'},
        {name:'销售', value: '2'},
        {name:'联合存储', value: '4'},
      ]
    };
  },
  components: { EditorBar },
  created() {
    this.getTableList()
    this.getCountry()
  },
  methods: {
    async submit() {
      this.ruleFormTwo.productContent = this.productContent
      this.ruleFormTwo.productContentEn = this.productContentEn
      let res = await this.$http.productAdd({...this.ruleFormTwo});
      if (res) {
        this.$message.success('操作成功！');
        this.dialogVisibleTwo=false;
        this.getTableList()
      }
    },
    async getCountry() {
      let res = await this.$http.areaBlacklistLibrary();
      if (res) {
        this.countryList = res.data
      }
    },
    getCont(row) {
      this.ruleFormTwo = {}
      this.dialogVisibleTwo = true
      this.ruleFormTwo = row
      this.productContent = row.productContent?row.productContent: ''
      this.productContentEn = row.productContentEn?row.productContentEn: ''
      // console.log((row.areaCodes))
      this.ruleFormTwo.areaCodes = row.areaCodes?JSON.stringify(row.areaCodes): null
    },
    getEidt(row) {
      this.dialogVisible = true
      this.ruleForm = row
      this.ruleForm.incomeType = row.incomeType.toString()
      this.ruleForm.showType = row.showType.toString()
      this.ruleForm.placeType = row.placeType.toString()
      this.ruleForm.productType = row.productType.toString()
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false
      this.getTableList()
    },
    getNumber (num) {
      return num.toFixed(2)
    },
    submitForm(formName) {
      let _this = this
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          console.log(this.ruleForm.rebate)
          if (this.ruleForm.rebate==0||this.ruleForm.rebate==2||this.ruleForm.rebate==3) {
          } else {
            this.$message.error('技术返点请填写0、2、3');
            return false
          }
          if (this.ruleForm.maxNum) {
            if (this.ruleForm.maxNum.length>5) {
              this.$message.error('最大购买份数不能大于99999份');
              return false
            }
            if (Number(this.ruleForm.maxNum)<Number(this.ruleForm.minNum)){
              this.$message.error('最大购买份数必须大于最小购买份数');
              return false
            }
          }
          this.ruleForm.areaCodes = this.ruleForm.areaCodes?JSON.stringify(this.ruleForm.areaCodes): null
          let res = await this.$http.productAdd({...this.ruleForm});
          if (res) {
            this.$message.success('操作成功！');
            this.dialogVisible=false;
            this.$nextTick(() => {
              this.$refs['ruleForm'].resetFields()
            })
            this.getTableList()
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    addFunc(){
      console.log(this.ruleForm)
      this.ruleForm={
        id:'',
        productName: '',
        productCurrency: 'FIL',
        contract: '',
        singeNum: '',
        repertory: '0',
        pledge: '',
        gasPledg: '',
        trus: '',
        productType: '1',
        showType: '0',
        placeType: '1',
        fixCost: '',
        basePrice: '',
        priceRange: '',
        incomeType: '1',
        incomeDelayDays: '',
        incomeStartDate: '',
        freezeRatio: '',
        freeCycle: '',
        priceStrategy: '',
        costDiscount: '',
        productNameEn: '',
        areaCodes: [],
        rebate: '0',
        minNum: '1',
        maxNum: null,
        fixCnyCost: null
      }
      this.dialogVisible=true;
      // this.ruleForm.areaCodes = 
    },
    async getTableList(val){
      if(val){
        this.searchForm.page=1;
      }
       let res = await this.$http.productList({...this.searchForm});
        if (res) {
          this.tableData=res.data.list
          console.log(this.tableData)
          this.totalNum = Number(res.data.totalSize)
        }
    },
    handleSizeChange(val) {
      this.searchForm.page = 1;
      this.searchForm.pageSize = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getTableList();
    }
  }
};
</script>

<style>
.productBox .el-date-editor.el-input, .productBox .el-date-editor.el-input__inner{
  width: 160px;
}
.quyu .el-select{
  width: 276px;
}
.contDialog .el-dialog__body{
  padding: 4px 20px;
}
.cont_ms .editor{
  height: 300px;
}
.cont_ms .text{
  height: 260px;
}
.cont_ms .w-e-text{
  min-height: 260px;
}
</style>
<style scoped>
.cont_ms{
  margin-bottom: 10px;
}
.cont_ms>div:first-child{
  margin-bottom: 10px;
}
</style>
